module.exports = __webpack_public_path__ + "static/media/cranio_placeholder_1.6559e282.png";